import {
  CREATE_CANTEEN_REQUEST,
  CREATE_CANTEEN_SUCCESS,
  CREATE_CANTEEN_FAILURE,
} from "../actions/canteenActions";

/* ================================
   INITIAL STATE
================================ */
const initialState = {
  loading: false,
  canteen: null,   // API response data
  success: false,
  error: null,
};

/* ================================
   CANTEEN REDUCER
================================ */
const canteenReducer = (state = initialState, action) => {
  switch (action.type) {

    /* ===== CREATE CANTEEN ===== */
    case CREATE_CANTEEN_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case CREATE_CANTEEN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        canteen: action.payload,
        error: null,
      };

    case CREATE_CANTEEN_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default canteenReducer;
